import { Schema, arrayOf } from 'normalizr';

import { getSegmentReduxId } from 'state/segments/schema/segmentEntityHelpers';
import { tileSchema } from 'state/tiles/schema/tilesSchema';

// Segment ids are not unique, they are unique in (id, editionId) key pair so we have to derive a unique key from these two
export const segmentSchema = new Schema('segment', { idAttribute: getSegmentReduxId });
segmentSchema.define({ tiles: arrayOf(tileSchema) });
